import { render, staticRenderFns } from "./TeamSpecificsCard.vue?vue&type=template&id=f6736770&"
import script from "./TeamSpecificsCard.vue?vue&type=script&lang=js&"
export * from "./TeamSpecificsCard.vue?vue&type=script&lang=js&"
import style0 from "./TeamSpecificsCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VIcon,VLayout})


/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6736770')) {
      api.createRecord('f6736770', component.options)
    } else {
      api.reload('f6736770', component.options)
    }
    module.hot.accept("./TeamSpecificsCard.vue?vue&type=template&id=f6736770&", function () {
      api.rerender('f6736770', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GroupTeams/Common/TeamSpecificsCard.vue"
export default component.exports